import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const applicant_id = createReducer(null, {
    [types.APPLICANT_POST](state, action) {
        let newState = action.applicant_id;
        return newState;
    }
});

export const applicants = createReducer(null, {
    [types.APPLICANT_GET](state, action) {
        let newState = { data: action.applicants, count: applicants };
        return newState;
    }
});

export const applicant = createReducer(null, {
    [types.APPLICANT_GET_BYID](state, action) {
        let newState = action.applicant;
        return newState;
    }
});


// WEBPACK FOOTER //
// ./src/reducers/applicant.js